'use client';

import { LoginBackground } from '@/components/login-background';
import { LoginCard } from '@/components/login-card';
import { Toaster } from '@/components/ui/sonner';
import { clearCachedToken } from '@/lib/client-request';
import { useAuth } from '@/providers/auth-provider';
import { useRouter, useSearchParams } from 'next/navigation';
import { useEffect } from 'react';

export default function LoginPage() {
  const router = useRouter();
  const searchParams = useSearchParams();
  const { user, updateUserInfo } = useAuth();
  const callback = searchParams.get('callback') || '/';

  useEffect(() => {
    if (user) router.replace(callback);
  }, [user, callback, router]);

  return (
    <div className="fixed inset-0 bg-background flex items-center justify-center p-4">
      <LoginBackground />
      <div className="relative z-10 w-full max-w-[600px] rounded-2xl bg-background border shadow-2xl overflow-hidden">
        <LoginCard
          referralCode={searchParams.get('referralCode')}
          onSuccess={async () => {
            clearCachedToken();
            await updateUserInfo();
            router.replace(callback);
          }}
          onCancel={() => router.replace('/')}
        />
      </div>
      <Toaster position="top-center" />
    </div>
  );
}
